import styled from "styled-components";

export const Container = styled.div`
  margin-top: 2rem;
  width: 98%;
  background: var(--white);
  border-radius: 5px;
  padding: 20px 30px;
  animation: ease 500ms slideDefault;
  display: flex;
  align-items: center;
  justify-content: center;

  .alert {
    font-size: 1.4rem;
  }

  .next-steps {
    font-size: 1.2rem;

    div {
      padding: 1rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        font-size: 1rem;
        width: 95%;
        padding: 1rem 1rem;
        font-weight: 600;
        margin: 0;
      }
    }
  }

  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      padding: 0.4rem 2.5rem;
    }
  }
`;
